import React, {FC} from 'react';
import {LeftSecondMenu} from "../../barsEnvironment/leftMenu/components/leftSecondMenu";
import {Routes} from "./routes";


export const Documents:FC = () => {
    return (
        <LeftSecondMenu>
            <Routes />
        </LeftSecondMenu>
    )
}
